import { render, staticRenderFns } from "./DownlineFileUploadAccess.vue?vue&type=template&id=2f13b2aa&scoped=true&"
import script from "./DownlineFileUploadAccess.vue?vue&type=script&lang=js&"
export * from "./DownlineFileUploadAccess.vue?vue&type=script&lang=js&"
import style0 from "./DownlineFileUploadAccess.vue?vue&type=style&index=0&id=2f13b2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13b2aa",
  null
  
)

export default component.exports